import Vue from 'vue';
import axios from 'axios';
import { Component, Prop } from 'vue-property-decorator';
import { IRahoituslaskin_v2, SopimuksenRajaArvot } from './IRahoituslaskin_v2';
import EventBus from '../Blogi/EventBus';
import Util from '../Blogi/Util';

let resi = Util.debounce(function () {
    EventBus.$emit("RAHOITUSLASKIN_RESIZE");
}, 50);

window.addEventListener("resize", resi);

declare var dataLayer: any;
declare var page: any

@Component({
    template: `<div class="webX-kontti">
                 <div class="rahoituslaskin_v2_wrapper" v-for="(laskin, index) in laskuriData">
                    <div class="rahoituslaskin_v2_column" id="rahoituslaskin_v2">
                        <div v-if="errors_kasiraha.length" class="error_text" v-for="error in errors_kasiraha">{{ error }}</div>
                        <div class="row header-row-h2">Käsiraha</div>
                        <div class="row number-input"> 
                            <input id="inputKasiraha" type="number" :placeholder="laskin.Kasiraha[0] + ' - ' + laskin.Kasiraha[laskin.Kasiraha.length-1] + ' €'" :min="laskin.Kasiraha[0]" :max="laskin.Kasiraha[laskin.Kasiraha.length-1]" v-model="this.valittuKasiraha" @keyup="paivitaKasirahaKeyup(this.valittuKasiraha, laskin.Kasiraha[0], laskin.Kasiraha[laskin.Kasiraha.length-1])" class="textInputField" />
                        </div>
                        <div class="row header-row-h2" style="padding-bottom: 0;">Sopimusaika</div>                        
                        <div class="row button-wrap">
                            <template v-for="(sopimusaika, index2) in laskin.Sopimusaika" v-if="laskin.Sopimusaika.length > 0">     
                                <input
                                    type="radio"
                                    :id="'rbl_sopimusaika_' + sopimusaika"
                                    name="rbl_sopimusaika"
                                    :value="sopimusaika"
                                    class="hidden radio-label"
                                    @change="paivitaSopimusaika(laskin, sopimusaika)"
                                    v-model="valittuSopimusaika"
                                    :disabled="isFetchingInProgress()"
                                />
                                <label :for="'rbl_sopimusaika_' + sopimusaika" class="button-label">
                                    <i class="sopimusaika-check"></i>{{ sopimusaika }} kk
                                </label>
                            </template>
                        </div>
                        <div v-if="errors_viimeinenera.length" class="error_text" v-for="error in errors_viimeinenera">{{ error }}</div>
                        <div class="row header-row-h2">Viimeinen erä</div>
                        <div class="row number-input" v-if="laskin.ViimeinenEra[0] != [laskin.ViimeinenEra.length-1]">
                            <input id="inputViimeinenEra" type="number" :placeholder="laskin.ViimeinenEra[0] + ' - ' + laskin.ViimeinenEra[laskin.ViimeinenEra.length-1] + ' €'" min="laskin.ViimeinenEra[0]" :max="laskin.ViimeinenEra[laskin.ViimeinenEra.length-1]" v-model="this.valittuViimeinenEra" @keyup="paivitaViimeinenEraKeyup(this.valittuViimeinenEra, laskin.ViimeinenEra[0], laskin.ViimeinenEra[laskin.ViimeinenEra.length-1])" class="textInputField" />
                        </div>
                        <div class="row number-input" v-if="laskin.ViimeinenEra[0] == [laskin.ViimeinenEra.length-1] && laskin.ViimeinenEra[0] == '0'">Kohteelle ei ole valittavissa viimeistä erää</div>
                        <div>
                            <input type="checkbox" id="chk_kampanjakoodi" value="1" v-model="showKampanjakoodi" @change="paivitaKampanjakoodiKeyup(this.valittuKampanjakoodi)" />
                            <label for="chk_kampanjakoodi">Minulla on kampanjakoodi</label>
                        </div>
                        <div class="row" style="margin-top: 10px;" v-if="showKampanjakoodi"><input type="text" id="kampanjakoodi" placeholder="Kampanjakoodi" v-model="this.valittuKampanjakoodi" @keyup="paivitaKampanjakoodiKeyup(this.valittuKampanjakoodi)" /></div>
                    </div>
                    <div class="rahoituslaskin_v2_column">
                        <div>
                            <div class="row header-row-h2">{{ laskin.PreDeal ? 'Kuukausierä Ostotarjoukseen' : 'Kuukausierä' }}</div>
                            <div class="row header-row-h2">{{laskin.Maksuera}} €/kk</div>
                        </div>
                        <div>
                            <div class="row header-row-h3">Lainaosuus</div>
                            <div class="row header-row-h3">{{laskin.UILainasumma}} €</div>
                        </div>
                        <div class="row" v-html="laskin.Lainaehdot"></div>
                        <div v-for="(laskin, index) in laskuriData" :class="[laskin.PreDeal ? 'row align_right' : 'row']" v-if="laskin.Kasiraha.length > 0">
                            <div :class="[laskin.PreDeal ? 'webX-sarake-deskari-100 webX-sarake-tablet-100 webX-sarake-100 desktop-keskelle mobile-keskelle' : 'webX-sarake-deskari-100 webX-sarake-tablet-100 webX-sarake-100 desktop-oikealle mobile-keskelle']">
                                <button id="rahoitusliidi-haelainaa-LTR2" class="istrackable" :data-analytics-link="[laskin.PreDeal ? 'rahoitusliidi-haelainaa-LTR2' : 'rahoitusliidi-haelainaa-LTR1']" type="button" :disabled="errors.length > 0" v-on:click="siirrylaskimeen(laskin)" :class="[laskin.PreDeal ? 'preDealButton' : '']">{{ laskin.PreDeal ? 'Jatka Ostotarjoukseen' : 'Hae ennakkopäätös' }}</button>
                                <button id="avaaSmileePortaali" class="js-avaa-smilee-portaali istrackable" data-analytics-link="Hae tarjous autosta" type="button">Hae tarjous autosta</button>
                                <input type="hidden" id="hiddenSopimusaika" :value="valittuSopimusaika"/>
                                <input type="hidden" id="hiddenKasiraha" :value="laskin.ValittuKasiraha"/>
                                <input type="hidden" id="hiddenAutonHinta" :value="autonhinta"/>
                                <input type="hidden" id="ytunnus" :value="ytunnus"/>
                                <input type="hidden" id="kategoria" :value="kategoria"/>
                                <input type="hidden" id="hiddenViimeinenEra" :value="valittuViimeinenEra"/>
                                <input type="hidden" id="hiddenLuotonPerustamismaksu" :value="laskin.valittuPerustamiskulu"/>
                                <input type="hidden" id="hiddenLaskutuslisa" :value="laskin.valittuLaskutuslisa"/>
                                <input type="hidden" id="hiddenKorko" :value="laskin.valittuKorko"/>
                                <input type="hidden" id="hiddenEuribor" :value="laskin.valittuEuribor"/>
                                <input type="hidden" id="hiddenKorkomarginaali" :value="laskin.valittuKorkomarginaali"/>
                                <input type="hidden" id="hiddenKampanjakoodi" :value="laskin.valittuKampanjakoodi"/>
                            </div>
                        </div>
                    </div>
                </div>                  
               </div>`,
    components: {
    }
})

export default class Rahoituslaskimet extends Vue {
    @Prop() autonhinta!: number;
    @Prop() autontunniste!: string;
    @Prop() showKampanjakoodi!: boolean;
    @Prop() ytunnus!: string;
    @Prop() kategoria!: number;

    valittuSopimusaika: number;
    valittuKasiraha: number;
    valittuViimeinenEra: number;
    valittuKampanjakoodi: string;
    valittuKorko: number;
    valittuEuribor: number;
    valittuKorkomarginaali: number;
    valittuPerustamiskulu: number;
    valittuLaskutuslisa: number;
    laskuriTunniste: number;
    rekisterinumero: string;
    avaaLaskurinLainaehdot = true;
    laskuriData: IRahoituslaskin_v2[] = [];
    sopimuksenRajaArvot: SopimuksenRajaArvot[] = [];
    csrfToken: string;
    errors: string[] = [];
    errors_kasiraha: string[] = [];
    errors_viimeinenera: string[] = [];
    timeoutId = null;

    ltrUrl: string = "";

    guid: string = "";

    fetchingInprogress: boolean = false;

    created() {
        this.initializeComponent();
    }

    async initializeComponent() {
        await this.haeRajaArvot();
        this.valittuSopimusaika = this.PalautaOletussopimusaika(this.sopimuksenRajaArvot);
        this.valittuKasiraha = 0;
        this.valittuViimeinenEra = 0;
        this.valittuKampanjakoodi = "";
        this.haeLaskelma();
    }

    haeRajaArvot(): Promise<void> {
        this.fetchingInprogress = true;
        let hinta: any = this.autonhinta;
        const payload = {
            "tunniste": this.autontunniste
        };

        this.csrfToken = document.querySelector<HTMLInputElement>("input[name = '__RequestVerificationToken']").value;

        if (hinta > 500) {
            return axios.post(`/JulkisetResurssit/HaeRahoitusLaskelmanRajaArvot`, payload, {
                headers: {
                    'content-type': 'application/json',
                    '__RequestVerificationToken': this.csrfToken
                }
            })
                .then(response => {
                    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                    this.sopimuksenRajaArvot = data;
                    this.fetchingInprogress = false;
                })
                .catch(e => {
                    this.fetchingInprogress = false;
                    console.error('error', e);
                });
        } else {
            return Promise.resolve();
        }
    }

    PalautaOletussopimusaika(sopimuksenRajaArvot: any): number {
        if (!Array.isArray(sopimuksenRajaArvot.Sopimusaika)) {
            console.error('Sopimusaika is not an array:', sopimuksenRajaArvot.Sopimusaika);
            return 24;
        }

        const maxSopimusaika = Math.max(...sopimuksenRajaArvot.Sopimusaika);
        return Math.min(maxSopimusaika, 60);
    }

    haeLaskelma() {
        this.fetchingInprogress = true;
        if (this.valittuViimeinenEra == undefined) {
            this.valittuViimeinenEra = 0;
        }
        let self = this;
        let hinta: any = this.autonhinta;
        const payload = {
            "tunniste": this.autontunniste,
            "hinta": Math.round(hinta),
            "caller_url": location.href,
            "ytunnus": this.ytunnus,
            "kategoria": this.kategoria,
            "sopimusaika": this.valittuSopimusaika,
            "kasiraha": this.valittuKasiraha,
            "viimeinenEra": this.valittuViimeinenEra,
            "kampanjakoodi": this.showKampanjakoodi ? this.valittuKampanjakoodi : "",
            "asetaSuurinYhteinenSopimusaika": true
        };

        this.csrfToken = document.querySelector<HTMLInputElement>("input[name = '__RequestVerificationToken']").value;

        if (hinta > 500) {
            axios.post(`/JulkisetResurssit/HaeRahoitusLaskelma`, payload, {
                headers: {
                    'content-type': 'application/json',
                    '__RequestVerificationToken': this.csrfToken
                }
            })
                .then(response => {
                    let data = response.data;
                    self.laskuriData = data;
                    this.paivitaLaskelma(self.laskuriData[0]);
                })
                .catch(e => {
                    this.fetchingInprogress = false;
                    console.error('error', e);
                });
        } else {
            this.fetchingInprogress = false;
            console.warn("Hinta on max 500€ -> ei haeta rahoituslaskureita.");
        }
    }

    mounted() {
    }

    updated() {
        this.naytaHaluttuRahoituspainike();
    }

    paivitaLaskelma(laskin: IRahoituslaskin_v2) {
        this.laskuriTunniste = laskin.LaskuriTunniste;
        this.rekisterinumero = laskin.Rekisterinumero;
        this.valittuKorko = laskin.valittuKorko;
        this.valittuEuribor = laskin.valittuEuribor;
        this.valittuKorkomarginaali = laskin.valittuKorkomarginaali;
        this.valittuPerustamiskulu = laskin.valittuPerustamiskulu;
        this.valittuLaskutuslisa = laskin.valittuLaskutuslisa;

        laskin.UILainasumma = laskin.LainaMaaraJosKasiraha0 - laskin.ValittuKasiraha;
        if (this.autonhinta > laskin.UILainasumma + laskin.ValittuKasiraha) {
            console.error("*** VIRHE *** Lainasumma + käsiraha on yhteensä vähemmän kuin auton hinta!");
        }

        let laskelma = laskin.Tulos;

        let maksueraString = laskelma.Maksuera.toString();
        maksueraString = maksueraString.replace(" €", "");

        let ehdot = laskin.Lainaehdot;

        ehdot = `Perustamismaksu ${laskelma.Perustamismaksu} €<br />
                Käsittelymaksu ${laskelma.Kasittelymaksu} €/kk<br />
                Lainankorko ${laskelma.Korko} %<br />`

        if (laskelma.Euribor.toString() != "") { ehdot += `Euribor ${laskelma.Euribor} %<br />` }
        if (laskelma.KorkoMarginaali.toString() != "") { ehdot += `Marginaali ${laskelma.KorkoMarginaali} % <br />` }

        ehdot += `Todellinen vuosikorko ${this.muotoile(laskelma.TodellinenVuosikorko)} %<br />
                Luottokustannukset ${this.muotoile(laskelma.LuottokustannuksetYhteensa)} €<br />
                KSL:n mukainen luottohinta ${this.muotoile(laskelma.KslLuottohinta)} €<br />
                Luottotyyppi: Kertaluotto<br />`

        if (laskin.PreDeal) {
            // Predeal
            ehdot += `<p>Kun olet viimeistellyt laskennan, voit siirtyä täydentämään Ostotarjouksen loput tiedot LähiTapiola Rahoituksen portaaliin. Siirtyminen ei vaadi tunnistautumista eikä vielä luo yhteydenottopyyntöä Jälleenmyyjälle. Laskentaa voit muuttaa vain täällä Autotien päässä ja laskenta siirtyy LähiTapiola Rahoituksen portaaliin.</p>`

        } else {
            // nonPredeal
            ehdot += `<p>Rahoitushakemuksen lähettäminen ei sido sinua mihinkään. Rahoituspäätös on vain ennakkopäätös. Käsitellyistä rahoitushakemuksista lähetetään myyjäliikkeelle ainoastaan yhteystiedot liikkeen yhteydenottoa varten. Lopulliset kaupan ehdot on aina sovittava myyjäliikkeessä, joka myös tekee lopullisen luottohakemuksen sopimillanne kaupan ehdoilla. Mikäli hakemustasi ei voida jostain syystä käsitellä loppuun, yhteystietojasi ei välitetä myyjäliikkeelle. Voit myös välittää yhteydenottopyynnön ilman rahoituslaskentaa painamalla nappia ”Ota yhteyttä myyjään” ja täyttämällä omat yhteystietosi lomakkeelle. Ennakkopäätöksen yhteydessä lasketaan myös vakuutuksen hinta ja tehdään luottotietojen tarkistus. Vakuutuslaskelma ei sido osapuolia mihinkään.</p>`

        }

        this.$set(this.laskuriData[0], 'Lainaehdot', ehdot);

        page.pageInfo.administrationfee = laskelma.Perustamismaksu;
        page.pageInfo.invoicefee = laskelma.Kasittelymaksu;
        page.pageInfo.interest = laskelma.Korko;

        this.$set(this.laskuriData[0], 'Maksuera', maksueraString);
        this.$set(this.laskuriData[0], 'Url', laskelma.Url);
        this.$set(this.laskuriData[0], 'UILainasumma', laskin.UILainasumma);

        console.log("Url: " + laskin.Url);

        this.guid = this.laskuriData[0].LTRGuid;
        this.fetchingInprogress = false;


        this.showKatsoRahoituspainike(this.laskuriData);
    }

    paivitaSopimusaika(laskin: IRahoituslaskin_v2, sopimusaika: number) {
        this.valittuSopimusaika = sopimusaika;
        this.haeLaskelma();
    }

    paivitaKasirahaKeyup(kasiraha: number, min: number, max: number) {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => this.paivitaKasiraha(kasiraha, min, max), 500);
    }

    paivitaKasiraha(kasiraha: number, min: number, max: number) {
        if (kasiraha.toString().length == 0) {
            kasiraha = 0;
        }

        const kasirahaJaViimeinenEra: number = parseFloat(kasiraha.toString()) + parseFloat(this.valittuViimeinenEra.toString());
        var element = document.getElementById("inputKasiraha");
        var element_viimeinenera = document.getElementById("inputViimeinenEra");

        if (kasiraha < min) {
            this.errors_kasiraha = [];
            this.errors_kasiraha.push("Tälle kohteelle pienin sallittu käsiraha on " + min + " euroa.");
            element.classList.add("error");
        }
        else if (kasiraha > max) {
            this.errors_kasiraha = [];
            this.errors_kasiraha.push("Tälle kohteelle suurin sallittu käsiraha on " + max + " euroa.");
            element.classList.add("error");
        }
        else if (kasirahaJaViimeinenEra > parseFloat(this.autonhinta.toString())) {
            this.errors_kasiraha = [];
            this.errors_kasiraha.push("Käsiraha ja viimeinen erä yhteensä " + kasirahaJaViimeinenEra + " euroa. Summa ei voi ylittää auton hintaa, " + this.autonhinta + " euroa.");
            element.classList.add("error");

            this.errors_viimeinenera = [];
            element_viimeinenera.classList.remove("error");
        }
        else {
            this.errors_kasiraha = [];
            element.classList.remove("error");

            if (kasirahaJaViimeinenEra <= parseFloat(this.autonhinta.toString())) {
                this.errors_viimeinenera = [];
                if (element_viimeinenera !== null) element_viimeinenera.classList.remove("error");
            }

            this.valittuKasiraha = kasiraha;
            this.haeLaskelma();
        }
    }

    paivitaViimeinenEraKeyup(ViimeinenEra: number, min: number, max: number) {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => this.paivitaViimeinenEra(ViimeinenEra, min, max), 500);
    }

    paivitaViimeinenEra(ViimeinenEra: number, min: number, max: number) {
        if (ViimeinenEra.toString().length == 0) {
            ViimeinenEra = 0;
        }

        const kasirahaJaViimeinenEra: number = parseFloat(ViimeinenEra.toString()) + parseFloat(this.valittuKasiraha.toString());
        var element = document.getElementById("inputViimeinenEra");
        var element_kasiraha = document.getElementById("inputKasiraha");

        if (ViimeinenEra < min) {
            this.errors_viimeinenera = [];
            this.errors_viimeinenera.push("Tälle kohteelle pienin sallittu viimeinen erä on " + min + " euroa.");
            element.classList.add("error");
        }
        else if (ViimeinenEra > max) {
            this.errors_viimeinenera = [];
            this.errors_viimeinenera.push("Tälle kohteelle suurin sallittu viimeinen erä " + max + " euroa.");
            element.classList.add("error");
        }
        else if (kasirahaJaViimeinenEra > parseFloat(this.autonhinta.toString())) {
            this.errors_viimeinenera = [];
            this.errors_viimeinenera.push("Käsiraha ja viimeinen erä yhteensä " + kasirahaJaViimeinenEra + " euroa. Summa ei voi ylittää auton hintaa, " + this.autonhinta + " euroa.");
            element.classList.add("error");

            this.errors_kasiraha = [];
            element_kasiraha.classList.remove("error");
        }
        else {
            this.errors_viimeinenera = [];
            element.classList.remove("error");

            if (kasirahaJaViimeinenEra <= parseFloat(this.autonhinta.toString())) {
                this.errors_kasiraha = [];
                element_kasiraha.classList.remove("error");
            }

            this.valittuViimeinenEra = ViimeinenEra;
            this.haeLaskelma();
        }
    }

    paivitaKampanjakoodiKeyup(Kampanjakoodi: string) {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => this.paivitaKampanjakoodi(Kampanjakoodi), 500);
    }

    paivitaKampanjakoodi(Kampanjakoodi: string) {
        this.valittuKampanjakoodi = Kampanjakoodi;
        this.haeLaskelma();
    }

    siirrylaskimeen(laskin: IRahoituslaskin_v2) {
        console.log("Siirrytään: " + laskin.Url);
        window.location.href = laskin.Url;
    }

    naytaHaluttuRahoituspainike() {
        var elem1 = document.getElementById("avaaSmileePortaaliPainike");
        var elem2 = document.getElementById("avaaSmileePortaaliPainikeMobiili");
        if ((typeof (elem1) == 'undefined' || elem1 == null) && (typeof (elem2) == 'undefined' || elem2 == null)) {
            document.getElementById("avaaSmileePortaali").style.display = "none";
        }
        else {
            document.getElementById("rahoitusliidi-haelainaa-LTR").style.display = "none";
        }
    }

    muotoile(arvo) {
        if (typeof arvo === "number") {
            var tempArvo = (arvo.toFixed(2)).replace('.', ',');
            tempArvo = ("" + tempArvo).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return tempArvo;
        } else if (typeof arvo === "string") {
            var tempArvo = arvo.replace('.', ',');
            tempArvo = tempArvo.slice(0, tempArvo.lastIndexOf(',') + 3);
            tempArvo = ("" + tempArvo).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return tempArvo;
        }
    }

    isFetchingInProgress() {
        return this.fetchingInprogress;
    }

    showKatsoRahoituspainike(laskuriData) {
        if (this.laskuriData.length != 0) {
            const elementKatsoRahoituspainike = document.getElementById('tietosivu__hinta-katsoRahoitusPainike');
            if (elementKatsoRahoituspainike) {
                elementKatsoRahoituspainike.style.display = 'inline';
            }
        }
    }
}
